/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField from '../../../../client/js/components/form/fields/FormField'
import {
  SITUATION_COHABITATION,
  SITUATION_MARRIED,
  SITUATION_SINGLE
} from '../../enums/FamilySituationCodes.mjs'
import { Select, SelectProps } from '@mantine/core'

export type FamilySituationFieldProps = Omit<SelectProps, 'data'>

function FamilySituationField (props: FamilySituationFieldProps) {
  const { name = 'familySituation', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'family_situation',
        defaultMessage: 'Situation familiale'
      })}
      {...others}
      name={name}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'undefined',
            defaultMessage: 'Non défini'
          }),
          value: ''
        },
        {
          label: intl.formatMessage({
            id: 'bachelor',
            defaultMessage: 'Célibataire'
          }),
          value: SITUATION_SINGLE
        },
        {
          label: intl.formatMessage({
            id: 'cohabitation',
            defaultMessage: 'Concubinage'
          }),
          value: SITUATION_COHABITATION
        },
        {
          label: intl.formatMessage({
            id: 'married',
            defaultMessage: 'Marié(e)'
          }),
          value: SITUATION_MARRIED
        }
      ]}
    />
  )
}

export default FamilySituationField
